import React, { useState } from 'react';
import {
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box
} from '@mui/material';
import { Button, Spacer } from 'src/components/shared';
import { bounceActionList } from 'src/modules/tasks/config';

function BounceActions({ onClick = () => { }, loading }) {
  const [selectedOption, setSelectedOption] = useState("");
  return (
    <>
      <Spacer y={1} />
      <FormControl fullWidth>
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          name="radio-buttons-group"
          value={selectedOption}
          onChange={(e) => setSelectedOption(e.target.value)}
        >
          {Object.keys(bounceActionList).map(key => (
            <FormControlLabel
              value={bounceActionList[key].value}
              control={<Radio variant="primary" />}
              label={bounceActionList[key].label}
            />
          ))}
        </RadioGroup>
      </FormControl>
      <Spacer y={3} />
      <Box display="flex" justifyContent="flex-end">
        <Button
          size="medium"
          variant="contained"
          type="submit"
          color="secondary"
          disabled={!selectedOption || loading}
          loading={loading}
          onClick={() => onClick(selectedOption)}
        >
          Confirm
        </Button>
      </Box>
    </>
  );
}

export default BounceActions;
